import React from 'react';
import PropTypes from 'prop-types';

class Theme extends React.Component {
  darkenColor(color) {
    let newColor = color.indexOf('rgb') < 0 ? color.replace('#', '') : color.replace('rgba(', '').replace('rgb(', '').replace(')', '').replace(' ', '').split(',');
    if (typeof newColor === 'string') {
      newColor = `#${newColor.split('').map((clr, c, clrList) => {
        const numcol = Number(clr);
        switch (clr.toLowerCase()) {
          case ('a'): return '9';
          case ('b'): return 'a';
          case ('c'): return 'b';
          case ('d'): return 'c';
          case ('e'): return 'd';
          case ('f'): return 'e';
          default: return numcol > 0 ? numcol - 1 : numcol;
        }
      }).join('')}`;
    } else {
      newColor = newColor.length < 4 ? `rgb(${newColor.map(clr => {
        return Number(clr) >= 10 ? Number(clr) - 10 : 0;
      }).join(', ')})` : `rgba(${newColor.map((clr, c) => {
        if (c >= 3) {
          return clr;
        }
        return Number(clr) >= 5 ? Number(clr) - 5 : 0;
      }).join(', ')})`;
    }
    return newColor;
  }

  componentDidMount() {
    const styleRef = document.createElement('STYLE');
    styleRef.innerHTML = `
       .skin-${this.props.name} .main-header .navbar {
         background-color: ${this.props.primary};
       }
       .skin-${this.props.name} .main-header .navbar .nav > li > a {
         color: ${this.props.hasDarkText ? '#333' : '#fff'};
       }
       .skin-${this.props.name} .main-header .navbar .nav > li > a:hover,
       .skin-${this.props.name} .main-header .navbar .nav > li > a:active,
       .skin-${this.props.name} .main-header .navbar .nav > li > a:focus,
       .skin-${this.props.name} .main-header .navbar .nav .open > a,
       .skin-${this.props.name} .main-header .navbar .nav .open > a:hover,
       .skin-${this.props.name} .main-header .navbar .nav .open > a:focus,
       .skin-${this.props.name} .main-header .navbar .nav > .active > a {
         background: rgba(0, 0, 0, 0.1);
         color: ${this.props.hasDarkText ? '#999' : '#f6f6f6'};
       }
       .skin-${this.props.name} .main-header .navbar .sidebar-toggle {
         color: ${this.props.hasDarkText ? '#333' : '#fff'};
       }
       .skin-${this.props.name} .main-header .navbar .sidebar-toggle:hover {
         color: ${this.props.hasDarkText ? '#999' : '#f6f6f6'};
         background: rgba(0, 0, 0, 0.1);
       }
       .skin-${this.props.name} .main-header .navbar .sidebar-toggle {
         color: ${this.props.hasDarkText ? '#333' : '#fff'};
       }
       .skin-${this.props.name} .main-header .navbar .sidebar-toggle:hover {
         background-color: ${this.props.secondary};
       }
       @media (max-width: 767px) {
         .skin-${this.props.name} .main-header .navbar .dropdown-menu li.divider {
           background-color: rgba(0, 0, 0, 0.1);
         }
         .skin-${this.props.name} .main-header .navbar .dropdown-menu li a {
           color: #333;
         }
       }
       .skin-${this.props.name} .main-header .logo {
         background-color: ${this.props.secondary};
         color: ${this.props.hasDarkText ? '#333' : '#fff'};
         border-bottom: 0 solid transparent;
       }
       .skin-${this.props.name} .main-header .logo:hover {
         background-color: ${this.darkenColor(this.props.secondary)};
       }
       .skin-${this.props.name} .main-header li.user-header {
         background-color: ${this.props.primary};
       }
       .skin-${this.props.name} .content-header {
         background: transparent;
       }
       .skin-${this.props.name} .wrapper,
       .skin-${this.props.name} .main-sidebar,
       .skin-${this.props.name} .left-side {
         background-color: #222d32;
       }
       .skin-${this.props.name} .user-panel > .info,
       .skin-${this.props.name} .user-panel > .info > a {
         color: ${this.props.hasDarkText ? '#333' : '#fff'};
       }
       .skin-${this.props.name} .sidebar-menu > li.header {
         color: #4b646f;
         background: #1a2226;
       }
       .skin-${this.props.name} .sidebar-menu > li > a {
         border-left: 3px solid transparent;
       }
       .skin-${this.props.name} .sidebar-menu > li:hover > a,
       .skin-${this.props.name} .sidebar-menu > li.active > a {
         color: #fff;
         background: #1e282c;
         border-left-color: ${this.props.primary};
       }
       .skin-${this.props.name} .main-sidebar-light { background-color: #f9f9f9; }
       .skin-${this.props.name} .main-sidebar-light > .sidebar .sidebar-menu > li a:hover,
       .skin-${this.props.name} .main-sidebar-light > .sidebar .sidebar-menu > li.treeview.active a {
         border-left-color: ${this.props.primary};
       }
       .skin-${this.props.name} .sidebar-menu > li > .treeview-menu {
         margin: 0 1px;
         background: #2c3b41;
       }
       .skin-${this.props.name} .sidebar a {
         color: #b8c7ce;
       }
       .skin-${this.props.name} .sidebar a:hover {
         text-decoration: none;
       }
       .skin-${this.props.name} .treeview-menu > li > a {
         color: #8aa4af;
       }
       .skin-${this.props.name} .treeview-menu > li.active > a,
       .skin-${this.props.name} .treeview-menu > li > a:hover {
         color: #fff;
       }
       .skin-${this.props.name} .sidebar-form {
         border-radius: 3px;
         border: 1px solid #374850;
         margin: 10px 10px;
       }
       .skin-${this.props.name} .sidebar-form input[type="text"],
       .skin-${this.props.name} .sidebar-form .btn {
         box-shadow: none;
         background-color: #374850;
         border: 1px solid transparent;
         height: 35px;
       }
       .skin-${this.props.name} .sidebar-form input[type="text"] {
         color: #666;
         border-top-left-radius: 2px;
         border-top-right-radius: 0;
         border-bottom-right-radius: 0;
         border-bottom-left-radius: 2px;
       }
       .skin-${this.props.name} .sidebar-form input[type="text"]:focus,
       .skin-${this.props.name} .sidebar-form input[type="text"]:focus + .input-group-btn .btn {
         background-color: #fff;
         color: #666;
       }
       .skin-${this.props.name} .sidebar-form input[type="text"]:focus + .input-group-btn .btn {
         border-left-color: #fff;
       }
       .skin-${this.props.name} .sidebar-form .btn {
         color: #999;
         border-top-left-radius: 0;
         border-top-right-radius: 2px;
         border-bottom-right-radius: 2px;
         border-bottom-left-radius: 0;
       }
       ${this.props.specialStyles}
    `;
    document.head.appendChild(styleRef);
  }
  render() {
    return null;
  }
}

Theme.propTypes = {
  name: PropTypes.string.isRequired,
  primary: PropTypes.string,
  secondary: PropTypes.string,
  hasDarkText: PropTypes.bool,
  specialStyles: PropTypes.string
};

Theme.defaultProps = {
  hasDarkText: false,
  primary: '#3c8dbc',
  secondary: '#357ca5',
  specialStyles: ''
};

export default Theme;
